import { useScrollReveal, useScrollRevealGroup } from '@/hooks/useScrollReveal';

const plans = [
  {
    name: 'Старт',
    leads: '',
    price: '20 000 ₽',
    period: '/ пакет',
    features: [
      'Перехват 500 номеров телефонов',
      'Сбор горячих контактов',
      'Ручной запуск AI-контакта',
      'Передача лидов в CRM',
      'Отчёт по пакету',
      'Поддержка в Telegram',
    ],
    highlighted: false,
  },
  {
    name: 'Бизнес',
    leads: '',
    price: '49 000 ₽',
    period: '/ пакет',
    features: [
      'Перехват 1500 номеров телефонов',
      'Все источники данных',
      'Автоматический AI-контакт',
      'Квалификация лидов',
      'Расширенная аналитика',
      'Персональный менеджер',
    ],
    highlighted: true,
  },
  {
    name: 'Максимум',
    leads: '',
    price: '120 000 ₽',
    period: '/ пакет',
    features: [
      'Перехват 5000 номеров телефонов',
      'Все источники + эксклюзивные',
      'AI-контакт + AI-рассыльщик',
      'Приоритетная обработка',
      'Интеграция с любыми CRM',
      'Выделенная команда поддержки',
    ],
    highlighted: false,
  },
];

export default function CompPricing() {
  const { ref: labelRef, revealed: labelRevealed } = useScrollReveal();
  const { ref: titleRef, revealed: titleRevealed } = useScrollReveal({ delay: 150 });
  const { containerRef: cardsRef, revealedCount: cardsRevealed } = useScrollRevealGroup<HTMLDivElement>(3);

  return (
    <section id="comp-pricing" className="py-20 md:py-28 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <div className="mb-12 md:mb-16 max-w-[640px]">
          <span ref={labelRef} className={`text-[12px] font-semibold uppercase tracking-[0.18em] text-primary-600 reveal-fade-up ${labelRevealed ? 'revealed' : ''}`}>
            Тарифы
          </span>
          <h2 ref={titleRef} className={`mt-4 font-display font-extrabold text-[34px] md:text-[46px] leading-[1.1] tracking-tightest text-foreground-950 reveal-fade-up ${titleRevealed ? 'revealed' : ''}`}>
            Выберите пакет
            <br />
            перехвата
          </h2>
        </div>

        <div ref={cardsRef} className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {plans.map((plan, i) => (
            <div
              key={plan.name}
              className={`rounded-xl p-6 md:p-7 flex flex-col reveal-fade-up ${i < cardsRevealed ? 'revealed' : ''} ${
                plan.highlighted
                  ? 'bg-primary-500 text-background-50 ring-2 ring-primary-500 ring-offset-2 ring-offset-background-100'
                  : 'bg-background-50 border border-background-200'
              }`}
              style={i < cardsRevealed ? { transitionDelay: `${i * 150}ms` } : undefined}
            >
              {plan.highlighted && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-3 py-1 text-[11px] font-semibold bg-background-50 text-primary-600 rounded-full whitespace-nowrap">
                  Популярный
                </span>
              )}

              <div className="mb-6">
                <p className={`text-sm ${plan.highlighted ? 'text-background-50/80' : 'text-foreground-500'}`}>{plan.leads}</p>
                <h3 className={`font-display font-bold text-[18px] ${plan.highlighted ? 'text-background-50' : 'text-foreground-950'}`}>{plan.name}</h3>
              </div>

              <div className="mb-6">
                <span className={`text-3xl md:text-4xl font-heading font-extrabold ${plan.highlighted ? 'text-background-50' : 'text-foreground-950'}`}>
                  {plan.price}
                </span>
                <span className={`text-sm ml-1 ${plan.highlighted ? 'text-background-50/70' : 'text-foreground-500'}`}>{plan.period}</span>
              </div>

              <ul className="space-y-3 mb-8 flex-1">
                {plan.features.map((f) => (
                  <li key={f} className="flex items-start gap-2.5 text-sm">
                    <i className={`ri-check-line mt-0.5 shrink-0 ${plan.highlighted ? 'text-background-50' : 'text-primary-500'}`}></i>
                    <span className={plan.highlighted ? 'text-background-50/90' : 'text-foreground-700'}>{f}</span>
                  </li>
                ))}
              </ul>

              <a
                href="https://lk.aigam.ru"
                className={`block w-full py-3 text-sm font-semibold rounded-md text-center transition-colors whitespace-nowrap cursor-pointer ${
                  plan.highlighted
                    ? 'bg-background-50 text-primary-600 hover:bg-background-100'
                    : 'bg-primary-500 text-background-50 hover:bg-primary-600'
                }`}
              >
                Выбрать {plan.name}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}